import { Component, OnInit } from '@angular/core';
import { MetadataService } from '../MetadataService';
import { AuthService } from '../auth.service';
import { Router, ActivatedRoute } from '@angular/router';
import { shareReplay, map } from 'rxjs';
import { Observable, forkJoin } from 'rxjs';
import { DataService } from '../dataService';
import { ConstantsService } from '../ConstantsService';
import { sortBy } from 'sort-by-typescript';
@Component({
  selector: 'app-candidate-profile',
  templateUrl: './candidate-profile.component.html',
  styleUrls: ['./candidate-profile.component.css']
})
export class CandidateProfileComponent implements OnInit {

  candidateData: any;
  experience: any[];
  education: any[];
  seminars: any[];
  candidateLanguages: any[];
  metadata$: Observable<any>;
  avatar: boolean = false;
  keycloakId: any;
  employmentTypes$: Observable<Array<{ id: number; name: string; }>>;
  items: any[];
  fileUrl: string;
  cv: File = null;
  cvMessage: string;
  metadataLanguages$: Observable<Array<{ id: number; name: string; }>>;
  prefectures$: Observable<Array<{ id: number; name: string; }>>;
  educationLevels$: Observable<Array<{ id: number; text: string }>>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public authService: AuthService,
    private metadataService: MetadataService,
    private dataService: DataService,
    private constants: ConstantsService
  ) { }

  ngOnInit() {

    this.route.params.subscribe((params) => {
      this.keycloakId = params.keycloakId ? params.keycloakId : this.authService.getCandidateKeycloakId();

      this.authService.getCandidateProfile(this.keycloakId).subscribe((data: any) => {
        //todo αν δεν τον βρει να τον εισαγει

        this.candidateData = data;
        this.experience = (this.candidateData.candidateExperienceWork || [])
          .sort(sortBy('-yearStart'));

        this.education = (this.candidateData.candidate_education || [])
          .sort(sortBy('-yearStart'));
        this.seminars = this.candidateData.candidateSeminars;
        this.candidateLanguages = this.candidateData.candidateLanguages;

        if (this.candidateData.imageId) {
          this.avatar = true;
          this.candidateData.image = this.authService.getLogo("candidate", "image", this.candidateData.keycloakId, new Date().getTime().toString());
        }
        else {
          this.avatar = false;
        }

        //get metadata
        this.metadata$ = this.metadataService.getMetaData()
          .pipe(shareReplay(1));

        this.employmentTypes$ = this.metadata$.pipe(
          map(
            metadata => metadata.employmentTypes.map(employmentType => ({ id: employmentType.id, text: employmentType.name }))
          )
        );

        this.metadataLanguages$ = this.metadata$.pipe(
          map(
            metadata => metadata.languages.map(languages => ({ id: languages.id, text: languages.name }))
          )
        );

        this.prefectures$ = this.metadata$.pipe(
          map(metadata => metadata.prefecture.map(prefecture => ({ id: prefecture.id, text: prefecture.name })))
        );

        this.educationLevels$ = this.metadata$.pipe(
          map(metadata => metadata.educationLevels.map(education_level => ({ id: education_level.id, text: education_level.name })))
        );

        this.getData();
      });
    });

  }

  completeProfile() {
    this.router.navigate(['candidates/complete-profile']);
  }

  getData() {

    this.employmentTypes$.subscribe((employmentTypes: any[]) => {
      this.experience.forEach(item => {
        let x = employmentTypes.find(locItem => locItem.id === item.employmentType);

        if (x) {
          item.employmentTypesName = x.text;
        }
        else {
          item.employmentTypesName = "–";
        }

      });
    });

    this.metadataLanguages$.subscribe((languages: any[]) => {

      this.candidateLanguages.forEach(item => {
        let x = languages.find(locItem => locItem.id === item.languageId);

        if (x) {
          item.languageName = x.text;
        }
        else {
          item.languageName = "";
        }
      });
    });

    this.prefectures$.subscribe((prefectures: any[]) => {
      let x = prefectures.find(prefecture => prefecture.id === this.candidateData.prefectureId);

      if (x) {
        this.candidateData.prefecture_name = x.text;
      }
      else {
        this.candidateData.prefecture_name = "";
      }

    });

    this.educationLevels$.subscribe((educationLevels: any[]) => {
      //  for the educationLvlId in cv info
      let x = educationLevels.find(education_level => education_level.id === this.candidateData.educationLvlId);
      if (x) {
        this.candidateData.educationLvlName = x.text;
      }
      else {
        this.candidateData.educationLvlName = "";
      }
      //  for the educationLvlId in education form
      this.education.forEach(item => {
        let x = educationLevels.find(locItem => locItem.id === item.educationLvlId);

        if (x) {
          item.educationLvlName = x.text;
        }
        else {
          item.educationLvlName = "";
        }
      });
    });
  }

  downLoadCv(candidateUuid) {
    const data = this.authService.downloadFile("candidate", "cv", new Date().getTime().toString(), candidateUuid);
    this.fileUrl = data;
  }

  appliedJobList() {
    this.router.navigate(['candidates/applied-job-list']);
  }

}
